import React, { useEffect, useState } from 'react'
import { IStoreState, useAppDispatch, useAppSelector } from '../../../../redux';
import { useOutletContext } from '../../../../providers';
import { Box, Button, Tab, Tabs } from '@mui/material';
import { a11yProps } from '../../../../Components/Tab/utils';
import { fetchSingleOutletLayoutsAsync, ITablesLayout } from '../../../../redux/tables';
import { useNavigate } from 'react-router-dom';
import { defaultReservation, IReservation } from '../../../../redux/reservations';
import { UpsertReservationDialog } from '../../../Reservations/dialogs/UpsertReservationDialog';
import { ControlledCustomSelect } from '../../../../Components/formComponents';
import { ISelectOption } from '../../../../constants/types';


interface ILayoutSelectorProps {
    disabled?: boolean
    value: string
    onChange: (val: ISelectOption) => void,
    error?: string
}
export const LayoutSelector: React.FC<ILayoutSelectorProps> = ({ disabled, value, onChange, error }) => {
    const { outlet_details: { outlet_uuid, outlet_name } } = useOutletContext()
    const dispatch = useAppDispatch();

    const {
        data: multipleDataArray,
    } = useAppSelector((storeState: IStoreState) => storeState.tables.layouts_list_without_tables);
    const [tabs, setTabs] = useState<ITablesLayout[]>([]);


    useEffect(() => {
        if (!outlet_uuid) return
        dispatch(fetchSingleOutletLayoutsAsync({outlet_uuid, exclude_layout_without_tables: true}))
    }, [outlet_uuid])


    useEffect(() => {
        if (multipleDataArray.length > 0) {
            setTabs(multipleDataArray)
        }
    }, [multipleDataArray])



    return (
        <>
            <ControlledCustomSelect
                label="Layout"
                name="layout_uuid"
                fullWidth
                disabled={disabled}
                options={multipleDataArray.map((layout) => ({ label: layout.layout_name, value: layout.layout_uuid as string }))}
                placeholder="Select Layout"
                value={value}
                onChange={(evt) => {
                    const newValue = multipleDataArray.find((layout) => layout.layout_uuid === evt.target.value)
                    if (newValue) onChange({label: newValue.layout_name, value: newValue.layout_uuid as string})

                }}
                error={error}
            />

        </>
    )
}
